// extracted by mini-css-extract-plugin
export default {"host":"style_host__-eVLS","label":"style_label__4VL8g"};